'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.presets = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;
exports.update = update;

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPDATE = 'ms/settings/update';

var presets = exports.presets = {
  unreal4: [{ type: 'normal', selected: true, mimeType: 'image/jpeg' }, { type: 'displacement', selected: true, mimeType: 'image/jpeg' }, { type: 'roughness', selected: true, mimeType: 'image/jpeg' }, { type: 'albedo', selected: true, mimeType: 'image/jpeg' }, { type: 'ao', selected: true, mimeType: 'image/jpeg' }, { type: 'metalness', selected: true, mimeType: 'image/jpeg' }, { type: 'cavity', selected: false, mimeType: 'image/jpeg' }, { type: 'gloss', selected: false, mimeType: 'image/jpeg' }, { type: 'bump', selected: false, mimeType: 'image/jpeg' }, { type: 'diffuse', selected: false, mimeType: 'image/jpeg' }, { type: 'specular', selected: false, mimeType: 'image/jpeg' }, { type: 'normalbump', selected: false, mimeType: 'image/jpeg' }, { type: 'translucency', selected: true, mimeType: 'image/jpeg' }, { type: 'opacity', selected: true, mimeType: 'image/jpeg' }, { type: 'fuzz', selected: true, mimeType: 'image/jpeg' }, { type: 'curvature', selected: false, mimeType: 'image/jpeg' }, { type: 'thickness', selected: false, mimeType: 'image/jpeg' }, { type: 'normalobject', selected: false, mimeType: 'image/jpeg' }],

  unity5metalness: [{ type: 'normal', selected: true, mimeType: 'image/jpeg' }, { type: 'displacement', selected: true, mimeType: 'image/jpeg' }, { type: 'gloss', selected: true, mimeType: 'image/jpeg' }, { type: 'albedo', selected: true, mimeType: 'image/jpeg' }, { type: 'ao', selected: true, mimeType: 'image/jpeg' }, { type: 'metalness', selected: true, mimeType: 'image/jpeg' }, { type: 'roughness', selected: false, mimeType: 'image/jpeg' }, { type: 'cavity', selected: false, mimeType: 'image/jpeg' }, { type: 'bump', selected: false, mimeType: 'image/jpeg' }, { type: 'diffuse', selected: false, mimeType: 'image/jpeg' }, { type: 'specular', selected: false, mimeType: 'image/jpeg' }, { type: 'normalbump', selected: false, mimeType: 'image/jpeg' }, { type: 'translucency', selected: true, mimeType: 'image/jpeg' }, { type: 'opacity', selected: true, mimeType: 'image/jpeg' }, { type: 'fuzz', selected: true, mimeType: 'image/jpeg' }, { type: 'curvature', selected: false, mimeType: 'image/jpeg' }, { type: 'thickness', selected: false, mimeType: 'image/jpeg' }, { type: 'normalobject', selected: false, mimeType: 'image/jpeg' }],

  unity5specular: [{ type: 'normal', selected: true, mimeType: 'image/jpeg' }, { type: 'displacement', selected: true, mimeType: 'image/jpeg' }, { type: 'gloss', selected: true, mimeType: 'image/jpeg' }, { type: 'albedo', selected: true, mimeType: 'image/jpeg' }, { type: 'ao', selected: true, mimeType: 'image/jpeg' }, { type: 'specular', selected: true, mimeType: 'image/jpeg' }, { type: 'metalness', selected: false, mimeType: 'image/jpeg' }, { type: 'cavity', selected: false, mimeType: 'image/jpeg' }, { type: 'roughness', selected: false, mimeType: 'image/jpeg' }, { type: 'bump', selected: false, mimeType: 'image/jpeg' }, { type: 'diffuse', selected: false, mimeType: 'image/jpeg' }, { type: 'normalbump', selected: false, mimeType: 'image/jpeg' }, { type: 'translucency', selected: true, mimeType: 'image/jpeg' }, { type: 'opacity', selected: true, mimeType: 'image/jpeg' }, { type: 'fuzz', selected: true, mimeType: 'image/jpeg' }, { type: 'curvature', selected: false, mimeType: 'image/jpeg' }, { type: 'thickness', selected: false, mimeType: 'image/jpeg' }, { type: 'normalobject', selected: false, mimeType: 'image/jpeg' }],

  offlineMetalness: [{ type: 'albedo', selected: true, mimeType: 'image/jpeg' }, { type: 'roughness', selected: true, mimeType: 'image/jpeg' }, { type: 'metalness', selected: true, mimeType: 'image/jpeg' }, { type: 'ao', selected: true, mimeType: 'image/jpeg' }, { type: 'displacement', selected: true, mimeType: 'image/jpeg' }, { type: 'bump', selected: true, mimeType: 'image/jpeg' }, { type: 'normal', selected: true, mimeType: 'image/jpeg' }, { type: 'gloss', selected: false, mimeType: 'image/jpeg' }, { type: 'specular', selected: false, mimeType: 'image/jpeg' }, { type: 'cavity', selected: false, mimeType: 'image/jpeg' }, { type: 'diffuse', selected: false, mimeType: 'image/jpeg' }, { type: 'normalbump', selected: true, mimeType: 'image/jpeg' }, { type: 'translucency', selected: false, mimeType: 'image/jpeg' }, { type: 'opacity', selected: false, mimeType: 'image/jpeg' }, { type: 'fuzz', selected: true, mimeType: 'image/jpeg' }, { type: 'curvature', selected: false, mimeType: 'image/jpeg' }, { type: 'thickness', selected: false, mimeType: 'image/jpeg' }, { type: 'normalobject', selected: false, mimeType: 'image/jpeg' }],

  offlineSpecular: [{ type: 'albedo', selected: true, mimeType: 'image/jpeg' }, { type: 'specular', selected: true, mimeType: 'image/jpeg' }, { type: 'ao', selected: true, mimeType: 'image/jpeg' }, { type: 'displacement', selected: true, mimeType: 'image/jpeg' }, { type: 'bump', selected: true, mimeType: 'image/jpeg' }, { type: 'normal', selected: true, mimeType: 'image/jpeg' }, { type: 'gloss', selected: true, mimeType: 'image/jpeg' }, { type: 'cavity', selected: false, mimeType: 'image/jpeg' }, { type: 'diffuse', selected: false, mimeType: 'image/jpeg' }, { type: 'metalness', selected: false, mimeType: 'image/jpeg' }, { type: 'roughness', selected: false, mimeType: 'image/jpeg' }, { type: 'normalbump', selected: true, mimeType: 'image/jpeg' }, { type: 'translucency', selected: false, mimeType: 'image/jpeg' }, { type: 'opacity', selected: false, mimeType: 'image/jpeg' }, { type: 'fuzz', selected: true, mimeType: 'image/jpeg' }, { type: 'curvature', selected: false, mimeType: 'image/jpeg' }, { type: 'thickness', selected: false, mimeType: 'image/jpeg' }, { type: 'normalobject', selected: false, mimeType: 'image/jpeg' }]
};

var init = {
  resolution: 8192,
  // workflow: 'metalness',
  // microsurface: 'roughness',
  preset: 'custom',

  meshMimeType: 'application/x-fbx',
  mimeType: 'image/jpeg',
  // maxlod: 3,
  // numberOfLods: 1,

  lod0: true,
  lod1: true,
  lod2: true,
  lod3: true,
  lod4: true,
  lod5: true,
  lod6: true,
  lod7: true,
  lod8: true,

  lodAlbedos: false,
  lodNormals: false,
  ztool: false,
  brushes: false,
  highpoly: false,
  vfx: false,

  components: [{ type: 'albedo', selected: true, mimeType: 'image/jpeg' }, { type: 'cavity', selected: false, mimeType: 'image/jpeg' }, { type: 'curvature', selected: false, mimeType: 'image/jpeg' }, { type: 'gloss', selected: false, mimeType: 'image/jpeg' }, { type: 'normal', selected: true, mimeType: 'image/jpeg' }, { type: 'normalbump', selected: false, mimeType: 'image/jpeg' }, { type: 'normalobject', selected: false, mimeType: 'image/jpeg' }, { type: 'displacement', selected: true, mimeType: 'image/jpeg' }, { type: 'bump', selected: false, mimeType: 'image/jpeg' }, { type: 'ao', selected: true, mimeType: 'image/jpeg' }, { type: 'metalness', selected: true, mimeType: 'image/jpeg' }, { type: 'diffuse', selected: false, mimeType: 'image/jpeg' }, { type: 'roughness', selected: true, mimeType: 'image/jpeg' }, { type: 'specular', selected: false, mimeType: 'image/jpeg' }, { type: 'fuzz', selected: false, mimeType: 'image/jpeg' }, { type: 'translucency', selected: true, mimeType: 'image/jpeg' }, { type: 'thickness', selected: false, mimeType: 'image/jpeg' }, { type: 'opacity', selected: true, mimeType: 'image/jpeg' }, { type: 'brush', selected: false, mimeType: 'image/jpeg' }, { type: 'mask', selected: false, mimeType: 'image/jpeg' }]
};

var initialState = {
  persistToLocalStorage: true,

  atlas: (0, _extends4.default)({}, init, {
    lod0: false,
    lod1: false,
    lod2: false,
    lod3: false,
    lod4: false,
    lod5: false,
    lod6: false,
    lod7: false,
    lod8: false,
    lodNormals: false,
    ztool: false,
    brushes: false,
    highpoly: false,
    vfx: false
  }),

  surface: (0, _extends4.default)({}, init, {
    lod0: false,
    lod1: false,
    lod2: false,
    lod3: false,
    lod4: false,
    lod5: false,
    lod6: false,
    lod7: false,
    lod8: false,
    lodNormals: false,
    ztool: false,
    brushes: false,
    highpoly: false,
    vfx: false
  }),

  brush: (0, _extends4.default)({}, init, {
    lod0: false,
    lod1: false,
    lod2: false,
    lod3: false,
    lod4: false,
    lod5: false,
    lod6: false,
    lod7: false,
    lod8: false,
    lodNormals: false,
    ztool: false,
    brushes: false,
    highpoly: false,
    vfx: false
  }),

  '3d': (0, _extends4.default)({}, init),

  '3dplant': (0, _extends4.default)({}, init)
};

// Reducer

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];


  switch (action.type) {
    case UPDATE:
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.payload.type, action.payload.settings));

    default:
      return state;
  }
}

// Action creators

function update(settings, type) {
  return {
    type: UPDATE,
    payload: {
      settings: settings,
      type: type
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/settings.js
// module id = 1127
// module chunks = 0